module.exports = __webpack_public_path__ + "img/img1.83e6e969.png";